import React, { ReactNode } from 'react';
import Spinner from 'components/spinner';

import { getSessionId, setRedirectUrl } from 'utils/sessionStorage';
import { redirectToAuthService } from 'utils/redirectToAuthService';

interface IWithAuth {
  children: ReactNode;
}

export default function WithAuth({ children }: IWithAuth) {
  if (getSessionId() === '') {
    setRedirectUrl(window.location.pathname);
    redirectToAuthService();
    return <Spinner />;
  }

  return <>{children}</>;
}
